import { render, staticRenderFns } from "./issue_card_weight.vue?vue&type=template&id=2e604aec&"
import script from "./issue_card_weight.vue?vue&type=script&lang=js&"
export * from "./issue_card_weight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports